export class Observable {
    constructor() {
        this.listeners = [];
        this.listen = (listener, context) => {
            this.listeners.push({ l: listener, c: context });
        };
        this.stopListen = (listener) => {
            const index = this.listeners.findIndex((l) => l.l === listener);
            if (index !== -1) {
                this.listeners.splice(index, 1);
            }
        };
        this.stopAllListen = () => {
            this.listeners.length = 0;
        };
        this.notifyAll = (v, context) => {
            this.listeners.forEach((l) => {
                if (context && l.c === context) {
                    return;
                }
                l.l(v);
            });
        };
        /**
         * Links the two observables so events raised in one will trigger the other one, and vice versa.
         * @param other The other observable to link with
         * @returns A function to unlink the two observables
         */
        this.link = (other) => {
            const thisListener = (v) => other.notifyAll(v, this);
            const otherListener = (v) => other.notifyAll(v, other);
            this.listen(thisListener, other);
            other.listen(otherListener, this);
            return () => {
                this.stopListen(thisListener);
                other.stopListen(otherListener);
            };
        };
        /**
         * @deprecated This function does not unlink properly. Use the returned value from {@link link} instead.
         * @param other The other observable to link with
         */
        this.unlink = (other) => {
            console.warn("The Observable.unlink() function has been deprecated. Use the returned value from link() instead");
        };
    }
}
